<app-nav></app-nav>

<section class="home">
  <div class="contenido">
    <div class="carousel">
      <img src="https://res.cloudinary.com/dtyvd3fim/image/upload/v1759323111/PresentacionValle_y9sz48.jpg"
        class="carousel-img active">
      <img src="https://res.cloudinary.com/dtyvd3fim/image/upload/v1765547958/comida2_g2tlvg.avif" class="carousel-img">
      <img src="https://res.cloudinary.com/dtyvd3fim/image/upload/v1765547930/lugar3_zbqsc7.jpg" class="carousel-img">
      <img src="https://res.cloudinary.com/dtyvd3fim/image/upload/v1765547956/comida_pisgdu.avif" class="carousel-img">
      <img src="https://res.cloudinary.com/dtyvd3fim/image/upload/v1765547930/lugar2_d4mutv.webp" class="carousel-img">
      <img src="https://res.cloudinary.com/dtyvd3fim/image/upload/v1765547957/comida3_np95d8.avif" class="carousel-img">
      <img src="https://res.cloudinary.com/dtyvd3fim/image/upload/v1765547930/lugar1_k5auyf.webp" class="carousel-img">
      <img src="https://res.cloudinary.com/dtyvd3fim/image/upload/v1764684142/Img_Parque_del_cafe_p5j2gi.jpg"
        class="carousel-img">
      <img src="https://res.cloudinary.com/dtyvd3fim/image/upload/v1765548533/lugar4_jr19vo.jpg" class="carousel-img">
    </div>

    <div class="hero-overlay">
      <span class="hero-badge">EJE CAFETERO · COLOMBIA</span>
      <h2>{{ 'HOME.TITLE' | translate }}</h2>
      <p class="hero-text">
        {{ 'HOME.SUBTITLE' | translate }}
      </p>
      <a href="/principal" class="hero-btn">{{ 'HOME.PRINCIPAL_BUTTON' | translate }}</a>

      <div class="hero-dots">
        <span class="hero-dot active"></span>
        <span class="hero-dot"></span>
        <span class="hero-dot"></span>
      </div>
    </div>
  </div>

  <div class="aliados">
    <h3>{{ 'HOME.BANNER' | translate }}</h3>
  </div>

  <div id="Nosotros" class="Nosotros">
    <div class="info1">
      <h2 style="text-transform: uppercase;">{{ 'NAV.ABOUT_US_TITLE' | translate }}</h2>
      <p>
        {{ 'HOME.ABOUT_US.DESC' | translate }}
      </p>
    </div>

    <div class="info2">
      <ul>
        <li>{{ 'HOME.ABOUT_US.INFO1' | translate }}</li>
        <li>{{ 'HOME.ABOUT_US.INFO2' | translate }}</li>
        <li>{{ 'HOME.ABOUT_US.INFO3' | translate }}</li>
        <li>{{ 'HOME.ABOUT_US.INFO4' | translate }}</li>
        <li>{{ 'HOME.ABOUT_US.INFO5' | translate }}</li>
      </ul>
    </div>
  </div>

  <div id="comoFunciona" class="panel-funciona">
    <h2>{{ 'NAV.HOW_WORKS_TITLE' | translate }}</h2>

    <div class="funciona-grid">
      <div class="funciona-card">
        <div class="step-number">1</div>
        <h3>{{ 'HOME.HOW_WORKS.TITLE1' | translate }}</h3>
        <p>{{ 'HOME.HOW_WORKS.DESC1' | translate }}</p>
      </div>

      <div class="funciona-card">
        <div class="step-number">2</div>
        <h3>{{ 'HOME.HOW_WORKS.TITLE2' | translate }}</h3>
        <p>{{ 'HOME.HOW_WORKS.DESC2' | translate }}</p>
      </div>

      <div class="funciona-card">
        <div class="step-number">3</div>
        <h3>{{ 'HOME.HOW_WORKS.TITLE3' | translate }}</h3>
        <p>{{ 'HOME.HOW_WORKS.DESC3' | translate }}</p>
      </div>
    </div>
  </div>

  <div class="cta-final">
    <h3>{{ 'HOME.FINAL_CTA_TITLE' | translate }}</h3>
    <p>{{ 'HOME.FINAL_CTA' | translate }}</p>
    <a href="/register" class="cta-final-btn">{{ 'HOME.FINAL_CTA_BUTTON' | translate }}</a>
  </div>
</section>

<app-footer></app-footer>